import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=459b34c2&"
import script from "./DashboardContent.vue?vue&type=script&lang=ts&"
export * from "./DashboardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports